import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { history, fetchWrapper } from "../_helpers";

// create slice

const name = "findInmates";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const findInmatesActions = { ...slice.actions, ...extraActions };
export const findInmatesReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    error: null,
    PublicUserSearchInmateResponse: [],
    PublicInmateConnectionRequestResponse: [],
  };
}

function createReducers() {
  return {
    clearEmailResponse,
    clearInmateConnectionStatus,
    clearInmateResponse
  };

  function clearInmateResponse(state) {
    state.PublicUserSearchInmateResponse = [];
  }

  function clearEmailResponse(state) {
    state.PublicInmateConnectionRequestResponse = [];
    state.user = null;
  }

  function clearInmateConnectionStatus(state) {
    state.CheckInmateConnectionStatus = null; // Clear the specific state
    state.InsertUpdateInmateStatus = null;
    state.saveFundTransferResponse = null;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/FindInmates`;

  return {
    PublicUserSearchInmate: PublicUserSearchInmate(),
    PublicInmateConnectionRequest: PublicInmateConnectionRequest(),
    UpdateInviteLinkUsageStatus:UpdateInviteLinkUsageStatus(),
    InmatesInfo:InmatesInfo()
  };
  function PublicUserSearchInmate() {
    return createAsyncThunk(
      `${name}/PublicUserSearchInmate`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/PublicUserSearchInmate`, data)
    );
  }
  function PublicInmateConnectionRequest() {
    return createAsyncThunk(
      `${name}/PublicInmateConnectionRequest`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/PublicInmateConnectionRequest`,
          data
        )
    );
  }

  function UpdateInviteLinkUsageStatus() {
    return createAsyncThunk(
      `${name}/UpdateInviteLinkUsageStatus`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/UpdateInviteLinkUsageStatus?inmateInvitePublicUserID=${data.InmateInvitePublicUserID}&pUIConnectionID=${data.PUIConnectionID}`,
        )
    );
  }

  function InmatesInfo() {
    return createAsyncThunk(
      `${name}/InmatesInfo`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/InmatesInfo?inmatesId=${data.InmateID}`
        )
    );
  }
  
  
}

function createExtraReducers(builder) {
  builder
    // Find Get findInmates
    .addCase(extraActions.PublicUserSearchInmate.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.PublicUserSearchInmate.fulfilled, (state, action) => {
      state.PublicUserSearchInmateResponse = [];
      state.PublicUserSearchInmateResponse = action.payload;
    })
    .addCase(extraActions.PublicUserSearchInmate.rejected, (state, action) => {
      state.error = action.error.message;
    })

    //PublicInmateConnectionRequest
    .addCase(extraActions.PublicInmateConnectionRequest.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.PublicInmateConnectionRequest.fulfilled,
      (state, action) => {
        state.PublicInmateConnectionRequestResponse = [];
        state.PublicInmateConnectionRequestResponse = action.payload;
      }
    )
    .addCase(
      extraActions.PublicInmateConnectionRequest.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

    //UpdateInviteLinkUsageStatus
    .addCase(extraActions.UpdateInviteLinkUsageStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.UpdateInviteLinkUsageStatus.fulfilled,
      (state, action) => {
      }
    )
    .addCase(
      extraActions.UpdateInviteLinkUsageStatus.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

    //InmatesInfo
    .addCase(extraActions.InmatesInfo.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.InmatesInfo.fulfilled,
      (state, action) => {
      }
    )
    .addCase(
      extraActions.InmatesInfo.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    );
}
